module.exports = __webpack_public_path__ + "img/375_stores_img5.5a5456eb.png";